import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import cn from 'classnames';

import styles from '../../styles/main/main.module.scss';
import StakeMore from '../../../../../../components/Stake/stake-more';
import UniIcon from '../../../../../../assets/images/tokens/uni-icon.png';
import Header from '../../../../../../components/Stake/header';
import * as uniV2StakeActions from '../../../../../../actions/uni-v2-stake-actions';
import { UNI_V2 } from '../../../../../../constants/blockchain-constants';
import stakeBackground from '../../../../../../assets/stake/stake-more-uni.svg';
import RewardPanel from '../reward-panel';

const Main = () => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.basic.dark);

  return (
    <>
      <Header icon={UniIcon} title='UNI OM V2/ETH-Staking' />
      <div className={cn({ [styles.dark]: dark })}>
        <div className={styles.stakeMoreWrapper}>
          <StakeMore
            type={UNI_V2}
            title='Stake More'
            image={stakeBackground}
            onClick={() => dispatch(uniV2StakeActions.stakeSettings())}
          />
        </div>
        <div className={cn(styles.unstakeContainer, styles.uni)}>
          <Button
            className={styles.unstakeButton}
            onClick={() => dispatch(uniV2StakeActions.unstakeSettings())}
            variant='contained'
          >
            Unstake
          </Button>
          <RewardPanel />
        </div>
      </div>
    </>
  );
};

export default Main;
